export const slugify = (text: string): string => {
  try {
    return text.trim().replace(/\W+/g, "-").replace(/[-]+$/, "").toLowerCase();
  } catch (e) {
    throw new Error(`Slugify error: ${e}`);
  }
};

export function getUrlExtension(
  url: string
): "JPG" | "JPEG" | "JFIF" | "WEBP" | "GIF" | "PNG" | "MP3" | "MP4" | "" {
  try {
    // https://the-garden.s3.us-east-1.amazonaws.com/garden-fullscreen:df1d01c322822a24d72f0fb863c33c6f883b888d2b6d4959f882c3123a6ca1bf:0.png:6538e2905b498c0105c5c504-v2-not-processed-DEV-DEl
    const split = url?.split(":")[3]?.split(/[#?]/)[0]?.split(".").pop();
    if (!split) {
      return "";
    }
    return split.trim().toLocaleUpperCase() as
      | "JPG"
      | "JPEG"
      | "JFIF"
      | "PNG"
      | "WEBP"
      | "MP3"
      | "MP4"
      | "";
  } catch (e) {
    throw new Error(`[Url extension]: ${e}`);
  }
}

export class TimeCheck {
  static checkFormat = (time: string): boolean => {
    return /^([1-2]?[0-9]|2[0-3]):[0-5][0-9] (AM|PM)$/.test(time);
  };

  static checkChars = (time: string) => {
    return /^[0-9:]*$/.test(time);
  };
}
